import {Injectable, Signal, signal} from '@angular/core';
import {toObservable} from '@angular/core/rxjs-interop';
import {Observable, Subject} from 'rxjs';
import {IModalClose, IModalConfirmation} from '../models/modal-confirmation.models';

@Injectable({
	providedIn: 'root',
})
export class DialogConfirmationService {
	// Define signals for dialog confirmation and close actions
	private _dialogConfirmation = signal<IModalConfirmation | null>(null);
	private $closeDialogConfirmation = new Subject<IModalClose>();

	public get dialogConfirmation(): Signal<IModalConfirmation | null> {
		return this._dialogConfirmation;
	}

	public setDialogConfirmation(value: IModalConfirmation): void {
		this._dialogConfirmation.set(value);
	}

	public getCloseDialogConfirmation(): Observable<IModalClose> {
		return this.$closeDialogConfirmation.asObservable();
	}

	public setCloseDialogConfirmation(value: IModalClose): void {
		this.$closeDialogConfirmation.next(value);
	}

	public show(conf: IModalConfirmation): Observable<IModalClose | undefined> {
		this.$closeDialogConfirmation?.complete(); // limpia suscriptores previos
		this.$closeDialogConfirmation = new Subject<IModalClose>();

		// Update the dialog confirmation signal
		this._dialogConfirmation.set({
			show: true,
			icon: conf?.icon || 'icon-alert',
			iconStatus: conf?.iconStatus || 'default',
			title: conf.title,
			description: conf.description || '',
			buttonPrimaryLabel: conf.buttonPrimaryLabel,
			buttonPrimaryStyle: conf.buttonPrimaryStyle ?? false,
			buttonSecondaryLabel: conf.buttonSecondaryLabel,
		});

		return this.$closeDialogConfirmation.asObservable();
	}

	public hide(): void {
		this._dialogConfirmation.set({show: false, title: ''});
	}
}
